class GiftingOptions extends HTMLElement {
  private _inventory?: InventoryItem[];
  private onSelect?: (item: InventoryItem) => void;
  selected?: InventoryItem;

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  set inventory(value: InventoryItem[]) {
    this._inventory = value;
    this.selected = value[0];
    this.render();
  }
  get inventory(): InventoryItem[] | undefined {
    return this._inventory;
  }

  connectedCallback() {
    this.render();
  }

  calculateSum() {
    if (!this.inventory || !this.shadowRoot) return;
    const selectedId = (this.shadowRoot.querySelector('input[type="radio"]:checked') as HTMLInputElement).value;
    const selected = this.inventory.find((i) => i.id.toString() === selectedId);

    if (!selected) return;
    this.selected = selected;
    this.onSelect && this.onSelect(selected);
  }

  render() {
    if (!this.inventory || !this.selected || !this.shadowRoot) return;

    this.shadowRoot.innerHTML = `
        <style>
            :host { color: inherit; }

            label {
              display: inline-flex;
              font-weight: 400;
              width: 100%;
              font-size: 1rem;
            }

            .container {
                display: flex;
                flex-direction: column;
                gap: 0.5rem;
            }

            input[type="radio"] {
              display: none;
            }

            .radio {
              display: flex;
              justify-content: center;
              align-items: center;
              min-width: 1.5rem;
              width: 1.5rem;
              height: 1.5rem;
              border: 0.12rem solid currentColor;
              border-radius: 50%;
              box-sizing: border-box;
              margin-block: auto;
              margin-right: 0.5rem;
            }

            .radio::after {
              content: '';
              width: 0.75rem;
              height: 0.75rem;
              border-radius: 50%;
              background-color: currentColor;
              opacity: 0;
              transform: scale(0.5);
              transition: opacity 0.1s ease, transform 0.1s ease;
            }

            input[type="radio"]:checked + .radio::after {
              opacity: 1;
              transform: scale(1);
            }

            .description {
                font-size: 0.8rem;
                color: gray;
            }
            .price {
                text-wrap: nowrap;
                margin-left: auto;
                font-size: 0.8rem;
                margin-block: auto;
            }
        </style> 
        <div class='container'>
            ${this.inventory
              .map(
                (inv, i) =>
                  `
                    <label>
                        <input type='radio' id='${inv.id}' name='coffee' value='${inv.id}' ${i === 0 ? 'checked' : ''}>
                        <span class='radio'></span>
                        <div style='display: flex; flex-direction: column;'>
                            <span class='label'>${inv.label}</span>
                            <span class='description'>${inv.description}</span>
                        </div>
                        <span class='price'>${inv.price / 100} NOK</span>
                    </label>`,
              )
              .reduce((p, c) => p + c)}
        </div>`;
    this.shadowRoot.innerHTML += `</div>`;
    const radioButtons = this.shadowRoot.querySelectorAll('input[type="radio"][name="coffee"]');
    radioButtons.forEach((radio) => {
      radio.addEventListener('change', this.calculateSum.bind(this));
    });
  }
}

customElements.define('gifting-options', GiftingOptions);
